// Request options builder - handles feature flag logic
import { IFetchDataRequest } from './types';
import { Features, isFeatureEnabled } from '../../stores/features';
import { getGrowthBookOverrideFlags } from '../../growthbook/getGrowthBookOverrideFlags';

/**
 * Returns the options used by fetch, including feature flag headers
 */
export const getCommonOptions = (request: IFetchDataRequest, accessToken: string, body: any) => {
  const options = {
    method: request.method || 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      ...request.headers,
    },
    body,
  };

  if (request.eTag) {
    options.headers['If-Match'] = request.eTag;
  }

  // Add feature flag headers if enabled
  if (isFeatureEnabled(Features.AllowFeatureFlagsHeaderOverride)) {
    const growthBookFlagOverrides = getGrowthBookOverrideFlags(window?.navigator?.userAgent);
    if (growthBookFlagOverrides) {
      options.headers['X-AQA-Feature-Flags-Override'] = growthBookFlagOverrides;
    }
  }

  return options;
};
